import { useDataModel } from '@thd-nucleus/data-sources';

/**
 * This Fetches visually similar items for OOO sku
 * @param itemID
 * @param hasVisuallySimilar
 */
export const useVisuallySimilar = ({
  itemID,
  hasVisuallySimilar
}) => {
  const opts = {
    variables: {
      anchorId: itemID,
      apiName: 'visuallysimilar_multi'
    },
    skip: !hasVisuallySimilar,
    ssr: false
  };
  const { data, loading, error } = useDataModel('recs', opts);

  const visuallySimilarSkus = data?.recs?.products?.map(({ product }) => product) || [];

  return { visSimSkus: visuallySimilarSkus, loading, error };
};
